import CloseRoundedIcon from "@mui/icons-material/CloseRounded";
import { Box, IconButton, Paper, Stack } from "@mui/material";
import CopyToBufferButton from "@entrilia/shared/components/inputs/CopyToBufferButton";
import TypographyTooltipEllipsis from "@entrilia/shared/components/TypographyTooltipEllipsis";
import UserAvatar from "@entrilia/shared/components/UserAvatar";

interface Props {
  name: string;
  email: string;
  onRemove?: () => void;
  removeDisabled?: boolean;
}

const OrganizationContactRow = ({ name, email, onRemove, removeDisabled }: Props) => (
  <Paper
    variant="outlined"
    sx={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 1, px: 1.5, py: 1 }}
  >
    <Stack direction="row" spacing={1.5} sx={{ alignItems: "center", flex: 1, minWidth: 0 }}>
      <Box sx={{ display: "flex", flexShrink: 0 }}>
        <UserAvatar userName={name} size="small" />
      </Box>
      <TypographyTooltipEllipsis
        text={name || email}
        observeContainerResize
        typographyProps={{ sx: { minWidth: 0 } }}
      />
      {name && (
        <TypographyTooltipEllipsis
          text={email}
          observeContainerResize
          typographyProps={{ color: "textSecondary", sx: { minWidth: 0 } }}
        />
      )}
    </Stack>
    <Stack direction="row" spacing={0.5} sx={{ alignItems: "center", flexShrink: 0 }}>
      <CopyToBufferButton textToCopy={email} />
      {onRemove && (
        <IconButton color="error" disabled={removeDisabled} onClick={onRemove}>
          <CloseRoundedIcon />
        </IconButton>
      )}
    </Stack>
  </Paper>
);

export default OrganizationContactRow;
